import { Text } from "@chakra-ui/react";

export const SalesCannotEditClosedSaleError = () => {
  return <Text>Cette vente a déjà été clôturée.</Text>;
};
